import script from "./StockDescriptions.vue?vue&type=script&setup=true&lang=js"
export * from "./StockDescriptions.vue?vue&type=script&setup=true&lang=js"

import "./StockDescriptions.vue?vue&type=style&index=0&id=9cd693b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cd693b0"]])

export default __exports__